import { APP_NAME_PATTERN } from '../utils/customApp';
import type { CustomAppConfig } from '../utils/customApp';
import type { CustomDetailsConfig } from '../customApps/customDetailsConfig';
import { CUSTOM_APP_BASE_URL } from '../config';

/**
 * Derives a full CustomDetailsConfig from a backend-provided CustomAppConfig.
 *
 * Maps the compact backend representation to the MFE coordinates needed by the
 * Module Federation runtime (remote name, manifest URL, exposed module, etc.).
 *
 * Returns `null` if `appName` does not match the allowed pattern.
 */
export function resolveAppConfig(
  app: CustomAppConfig,
  entityName: string
): CustomDetailsConfig | null {
  const { appName } = app;

  if (!APP_NAME_PATTERN.test(appName)) {
    return null;
  }

  return {
    entityName,
    remoteName: appName,
    remoteEntry: `${CUSTOM_APP_BASE_URL}/${appName}/mf-manifest.json`,
    remoteModule: `${appName}/App`,
    testIdObject: `${appName}-container`,
    defaultRouteEntity: entityName,
  };
}
